"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _consts = require("../consts");

var getAlign = function getAlign(align) {
  var _tokens;

  var tokens = (_tokens = {}, (0, _defineProperty2.default)(_tokens, _consts.ALIGNS.START, "flex-start"), (0, _defineProperty2.default)(_tokens, _consts.ALIGNS.END, "flex-end"), (0, _defineProperty2.default)(_tokens, _consts.ALIGNS.CENTER, "center"), (0, _defineProperty2.default)(_tokens, _consts.ALIGNS.STRETCH, "stretch"), (0, _defineProperty2.default)(_tokens, _consts.ALIGNS.BASELINE, "baseline"), _tokens);
  return align && tokens[align];
};

var _default = getAlign;
exports.default = _default;